import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import { Modal } from 'react-bootstrap';
import { putRequest, postRequest, getRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import infoIcon from '../../../../assets/images/icons/blue-info-icon.svg';
import ExpertiseTagDropdown from '../../common/ExpertiseTagDropdown';
import '../ProjectDetails.scss';
import FilterTag from '../../common/FilterTag';
import customStyles from '../../../dropdownStyleUtils';
import DropdownIndicator from '../../common/DropdownIndicator';
var formStep = 'start';
var filterPicklist = function filterPicklist(picklist, input) {
  return picklist.filter(function (record) {
    return record.label.toLowerCase().includes(input.toLowerCase());
  });
};
var handleTrackEvent = function handleTrackEvent() {
  return analyticsTrack('Navigated away from new project', 'Project creation');
};
var numericKeyFilter = function numericKeyFilter(e) {
  var re = /[0-9]/;
  if (e.keyCode === 8 || e.keyCode === 46 || e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40) {
    return;
  }
  if (!re.test(e.key)) {
    e.preventDefault();
  }
};
var ProjectName = /*#__PURE__*/function (_Component) {
  function ProjectName(props) {
    var _this;
    _classCallCheck(this, ProjectName);
    _this = _callSuper(this, ProjectName, [props]);
    _this.state = {
      projectName: props.projectName,
      showModal: false,
      errors: null,
      selectedProjectLength: null,
      selectedDurationUnit: props.newProjectDetails.duration_unit || 'months',
      companyId: props.companyId,
      expertiseTags: props.newProjectDetails.expertise_tags,
      expertisePicklists: props.newProjectDetails.expertise_picklists,
      projectTemplates: [],
      selectedAvgHoursPerWeek: props.newProjectDetails.avg_time_required_range || '',
      selectedAvgHoursUnit: props.newProjectDetails.avg_time_required_unit || 'week',
      employmentType: props.newProjectDetails.employment_type
    };
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleHideModal = _this.handleHideModal.bind(_this);
    _this.handleBack = _this.handleBack.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleRoleSelect = _this.handleRoleSelect.bind(_this);
    _this.handleLevelSelect = _this.handleLevelSelect.bind(_this);
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.handleEmploymentTypeSelect = _this.handleEmploymentTypeSelect.bind(_this);
    _this.handleSelectTemplate = _this.handleSelectTemplate.bind(_this);
    _this.setName = _this.setName.bind(_this);
    _this.getProjectTemplates = _this.getProjectTemplates.bind(_this);
    return _this;
  }
  _inherits(ProjectName, _Component);
  return _createClass(ProjectName, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        projectResourceId = _this$props.projectResourceId,
        getProjectDetails = _this$props.getProjectDetails,
        projectTemplatesPath = _this$props.projectTemplatesPath,
        projectTemplateId = _this$props.projectTemplateId;
      if (projectResourceId) {
        getProjectDetails(formStep).then(function (response) {
          var data = response.data;
          _this2.setState({
            projectName: data.name,
            companyId: data.company_id,
            expertiseTags: data.expertise_tags,
            expertisePicklists: data.expertise_picklists,
            selectedProjectLength: data.duration_range,
            selectedDurationUnit: data.duration_unit || 'months',
            selectedAvgHoursPerWeek: data.avg_time_required_range || '',
            selectedAvgHoursUnit: data.avg_time_required_unit || 'week'
          });
        });
      } else {
        window.addEventListener('beforeunload', handleTrackEvent);
      }
      if (projectTemplatesPath) {
        this.getProjectTemplates(function () {
          return _this2.handleSelectTemplate(projectTemplateId);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', handleTrackEvent);
    }
  }, {
    key: "getProjectTemplates",
    value: function getProjectTemplates(callback) {
      var _this3 = this;
      var projectTemplatesPath = this.props.projectTemplatesPath;
      getRequest(projectTemplatesPath).then(function (response) {
        _this3.setState({
          projectTemplates: response.data
        }, callback);
      });
    }
  }, {
    key: "setName",
    value: function setName(e) {
      this.setState({
        projectName: e.target.value
      });
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      var isAdmin = this.props.isAdmin;
      var _this$state = this.state,
        projectName = _this$state.projectName,
        selectedProjectLength = _this$state.selectedProjectLength,
        expertiseTags = _this$state.expertiseTags,
        selectedAvgHoursPerWeek = _this$state.selectedAvgHoursPerWeek,
        selectedDurationUnit = _this$state.selectedDurationUnit,
        companyId = _this$state.companyId,
        employmentType = _this$state.employmentType;
      var maxDuration = selectedDurationUnit === 'weeks' ? 104 : 24;
      return projectName.length > 3 && (!isAdmin || companyId) && expertiseTags.higher_level_role_ids.length && expertiseTags.level_ids.length && (employmentType === 'full_time' || employmentType === 'consulting' && selectedProjectLength && selectedProjectLength > 0 && selectedProjectLength <= maxDuration && selectedAvgHoursPerWeek && selectedAvgHoursPerWeek > 0);
    }
  }, {
    key: "handleSelectTemplate",
    value: function handleSelectTemplate(templateId) {
      var _this$state2 = this.state,
        projectTemplates = _this$state2.projectTemplates,
        expertiseTags = _this$state2.expertiseTags;
      var userId = this.props.userId;
      if (!templateId) return;
      var chosenTemplate = projectTemplates.find(function (template) {
        return template.id === templateId;
      });
      var allTags = expertiseTags;
      allTags.level_ids = chosenTemplate.seniorities;
      allTags.higher_level_role_ids = chosenTemplate.roles;
      analyticsTrack("Selected Project Template: ".concat(chosenTemplate.name), {
        templateName: chosenTemplate.name,
        eventId: 'templateButtonClickEvent',
        eventType: 'buttonClick',
        timestamp: Date.now(),
        userId: userId
      });
      this.setState({
        selectedTemplate: templateId,
        expertiseTags: allTags,
        projectName: chosenTemplate.name
      });
    }
  }, {
    key: "handleRoleSelect",
    value: function handleRoleSelect() {
      var _this4 = this;
      var expertiseTags = this.state.expertiseTags;
      return function (tags) {
        var allTags = expertiseTags;
        allTags.higher_level_role_ids = tags.length >= 1 ? [tags[tags.length - 1].value] : [];
        if (tags.length >= 1) {
          analyticsTrack("Selected Higher Level Role: ".concat(tags[tags.length - 1].label), {
            location: 'Project creation'
          });
        }
        _this4.setState({
          expertiseTags: allTags
        });
      };
    }
  }, {
    key: "handleEmploymentTypeSelect",
    value: function handleEmploymentTypeSelect(choice) {
      this.setState({
        employmentType: choice
      });
    }
  }, {
    key: "handleLevelSelect",
    value: function handleLevelSelect() {
      var _this5 = this;
      var expertiseTags = this.state.expertiseTags;
      return function (tags) {
        var allTags = expertiseTags;
        allTags.level_ids = tags.map(function (t) {
          return t.value;
        });
        if (tags.length >= 1) {
          analyticsTrack("Selected Seniority: ".concat(tags[tags.length - 1].label), {
            location: 'Project creation'
          });
        }
        _this5.setState({
          expertiseTags: allTags
        });
      };
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleHideModal",
    value: function handleHideModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "handleBack",
    value: function handleBack() {
      if (this.props.formType === 'page') {
        this.props.back();
      } else {
        this.handleHideModal();
      }
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(opt) {
      this.setState({
        companyId: opt.value
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this6 = this;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        projectUrl = _this$props2.projectUrl,
        projectResourceId = _this$props2.projectResourceId,
        afterSubmit = _this$props2.afterSubmit,
        setProjectResourceId = _this$props2.setProjectResourceId,
        isAdmin = _this$props2.isAdmin,
        favoritedConsultant = _this$props2.favoritedConsultant;
      var _this$state3 = this.state,
        projectName = _this$state3.projectName,
        companyId = _this$state3.companyId,
        expertiseTags = _this$state3.expertiseTags,
        selectedProjectLength = _this$state3.selectedProjectLength,
        selectedDurationUnit = _this$state3.selectedDurationUnit,
        selectedAvgHoursPerWeek = _this$state3.selectedAvgHoursPerWeek,
        selectedAvgHoursUnit = _this$state3.selectedAvgHoursUnit,
        selectedTemplate = _this$state3.selectedTemplate,
        employmentType = _this$state3.employmentType;
      var data = {
        name: projectName,
        higher_level_role_ids: expertiseTags.higher_level_role_ids,
        level_ids: expertiseTags.level_ids,
        duration_range: selectedProjectLength,
        duration_unit: selectedDurationUnit,
        avg_time_required_range: selectedAvgHoursPerWeek,
        avg_time_required_unit: selectedAvgHoursUnit,
        employment_type: employmentType
      };
      if (favoritedConsultant) {
        data.favorited_consultant = favoritedConsultant;
      }
      if (isAdmin) {
        data.company_id = companyId;
      }
      if (this.props.rehireUserResourceId) {
        data.rehire_user_resource_id = this.props.rehireUserResourceId;
      }
      if (projectResourceId) {
        putRequest("/projects/".concat(projectResourceId), {
          project: data
        }, csrfToken).then(function () {
          afterSubmit();
        })["catch"](function (error) {
          _this6.setState({
            errors: error.name
          });
        });
      } else {
        if (this.props.duplicationProjectResourceId) {
          data.project_resource_id = this.props.duplicationProjectResourceId;
        }
        postRequest(projectUrl, {
          project: data,
          template: selectedTemplate
        }, csrfToken).then(function (response) {
          setProjectResourceId(afterSubmit)(response.data.resource_id);
        })["catch"](function (error) {
          _this6.setState({
            errors: error.name
          });
        });
      }
    }
  }, {
    key: "renderFlashMessages",
    value: function renderFlashMessages() {
      var _this$props3 = this.props,
        jobDescriptionUpload = _this$props3.jobDescriptionUpload,
        projectTemplateId = _this$props3.projectTemplateId;
      if (jobDescriptionUpload || projectTemplateId) {
        return /*#__PURE__*/React.createElement("div", {
          className: "info-blurb mb-2"
        }, /*#__PURE__*/React.createElement("img", {
          src: infoIcon,
          alt: "info-icon"
        }), /*#__PURE__*/React.createElement("div", {
          className: "message"
        }, /*#__PURE__*/React.createElement("h3", null, jobDescriptionUpload && "We've imported your job description", projectTemplateId && "We've pre-filled the project info from the template you selected", /*#__PURE__*/React.createElement("span", {
          className: "ms-2",
          role: "img",
          "aria-label": "thumbs-up"
        }, "\uD83D\uDC4D")), /*#__PURE__*/React.createElement("span", null, "Check the details and edit as needed.")));
      }
      return null;
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      return /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showModal,
        onHide: this.handleHideModal,
        dialogClassName: "project-name-modal"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "project-name-modal-body"
      }, this.renderContent()));
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this$props4 = this.props,
        backButtonText = _this$props4.backButtonText,
        submitButtonText = _this$props4.submitButtonText;
      return /*#__PURE__*/React.createElement("div", {
        className: "footer-buttons-container mt-4"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary button-back",
        onClick: this.handleBack
      }, backButtonText), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary button-submit text-white",
        onClick: this.handleSubmit,
        disabled: !this.canSubmit()
      }, submitButtonText));
    }
  }, {
    key: "renderProjectLengthQuestion",
    value: function renderProjectLengthQuestion() {
      var _this7 = this;
      var _this$state4 = this.state,
        selectedProjectLength = _this$state4.selectedProjectLength,
        selectedDurationUnit = _this$state4.selectedDurationUnit;
      var maxDuration = selectedDurationUnit === 'weeks' ? 104 : 24;
      var durationLabel = selectedDurationUnit === 'weeks' ? 'weeks' : 'months';
      return /*#__PURE__*/React.createElement("div", {
        className: "project-length-question mt-3"
      }, /*#__PURE__*/React.createElement("h3", null, "Length of engagement", /*#__PURE__*/React.createElement("span", {
        className: "heading-required"
      }, "* Required")), /*#__PURE__*/React.createElement("div", {
        className: "project-length-container mt-2"
      }, /*#__PURE__*/React.createElement("input", {
        placeholder: "",
        type: "number",
        id: "project-length",
        name: "project-length",
        value: selectedProjectLength,
        onKeyDown: numericKeyFilter,
        onChange: function onChange(e) {
          return _this7.setState({
            selectedProjectLength: e.target.value
          });
        }
      }), /*#__PURE__*/React.createElement("select", {
        className: "project-time-unit-select ms-2",
        "aria-label": "Length of engagement unit",
        value: selectedDurationUnit,
        onChange: function onChange(e) {
          return _this7.setState({
            selectedDurationUnit: e.target.value
          });
        }
      }, /*#__PURE__*/React.createElement("option", {
        value: "months"
      }, "months"), /*#__PURE__*/React.createElement("option", {
        value: "weeks"
      }, "weeks"))), selectedProjectLength && selectedProjectLength > maxDuration && /*#__PURE__*/React.createElement("div", {
        className: "error-text"
      }, "Cannot be more than ".concat(maxDuration, " ").concat(durationLabel, ".")));
    }
  }, {
    key: "renderProjectHoursQuestion",
    value: function renderProjectHoursQuestion() {
      var _this8 = this;
      var _this$state5 = this.state,
        selectedAvgHoursPerWeek = _this$state5.selectedAvgHoursPerWeek,
        selectedAvgHoursUnit = _this$state5.selectedAvgHoursUnit;
      return /*#__PURE__*/React.createElement("div", {
        className: "project-hours-question mt-3"
      }, /*#__PURE__*/React.createElement("h3", null, "Average hours", /*#__PURE__*/React.createElement("span", {
        className: "heading-required"
      }, "* Required")), /*#__PURE__*/React.createElement("div", {
        className: "project-hours-container mt-2"
      }, /*#__PURE__*/React.createElement("input", {
        placeholder: "",
        type: "number",
        name: "project-hours",
        id: "project-hours",
        min: "1",
        value: selectedAvgHoursPerWeek,
        onKeyDown: numericKeyFilter,
        onChange: function onChange(e) {
          return _this8.setState({
            selectedAvgHoursPerWeek: e.target.value
          });
        }
      }), /*#__PURE__*/React.createElement("select", {
        className: "project-time-unit-select ms-2",
        "aria-label": "Average hours unit",
        value: selectedAvgHoursUnit,
        onChange: function onChange(e) {
          return _this8.setState({
            selectedAvgHoursUnit: e.target.value
          });
        }
      }, /*#__PURE__*/React.createElement("option", {
        value: "week"
      }, "hours per week"), /*#__PURE__*/React.createElement("option", {
        value: "month"
      }, "hours per month"))));
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var errors = this.state.errors;
      return errors && /*#__PURE__*/React.createElement("div", {
        id: "error_explanation"
      }, /*#__PURE__*/React.createElement("h3", null, "Errors prohibited this project from being saved:"), /*#__PURE__*/React.createElement("ul", null, errors.map(function (e) {
        return /*#__PURE__*/React.createElement("li", null, e);
      })));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props5 = this.props,
        isAdmin = _this$props5.isAdmin,
        companyPicklist = _this$props5.companyPicklist,
        newProjectDetails = _this$props5.newProjectDetails,
        showFullTimeOption = _this$props5.showFullTimeOption;
      var _this$state6 = this.state,
        companyId = _this$state6.companyId,
        expertiseTags = _this$state6.expertiseTags,
        expertisePicklists = _this$state6.expertisePicklists,
        employmentType = _this$state6.employmentType;
      var selection = isAdmin && companyId ? companyPicklist.find(function (opt) {
        return opt.value === companyId;
      }) : null;
      var roleSelection = expertiseTags.higher_level_role_ids.map(function (id) {
        return expertisePicklists.higher_level_role.find(function (o) {
          return o.value === id;
        });
      });
      var levelSelection = expertiseTags.level_ids.map(function (id) {
        return expertisePicklists.level.find(function (o) {
          return o.value === id;
        });
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide project-name-container"
      }, isAdmin && /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-6"
      })), /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-6 name-entry-container"
      }, this.renderErrors(), this.renderFlashMessages(), isAdmin && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        className: "v3"
      }, "What company is this project for?"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(AsyncSelect, {
        components: {
          DropdownIndicator: DropdownIndicator,
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          }
        },
        styles: customStyles,
        classNamePrefix: "clora-multiselect",
        closeMenuOnSelect: true,
        value: selection,
        className: "project-company-select",
        id: "project-company-select",
        onChange: this.handleSelect,
        placeholder: "Search",
        marginTop: "5",
        defaultOptions: companyPicklist,
        loadOptions: function loadOptions(input) {
          return new Promise(function (resolve) {
            resolve(filterPicklist(companyPicklist, input));
          });
        },
        cacheOptions: true,
        isSearchable: true
      }), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("h2", {
        className: "v3"
      }, "High-Level Information about this Project"), /*#__PURE__*/React.createElement("h3", {
        className: "mt-3"
      }, "Title", /*#__PURE__*/React.createElement("span", {
        className: "heading-required"
      }, "* Required")), /*#__PURE__*/React.createElement("div", {
        className: "input-sub-heading"
      }, "Use a descriptive title since this is one of the first thing candidates will see.", ' ', /*#__PURE__*/React.createElement("br", null), "Example: Medical Writer to Support IND Submission for Oncology Program"), /*#__PURE__*/React.createElement("input", {
        name: "projectName",
        id: "projectName",
        className: "project-name-entry",
        required: "required",
        value: this.state.projectName,
        onChange: this.setName,
        placeholder: "Project title"
      }), /*#__PURE__*/React.createElement("div", {
        className: "project-expertise-select higher_level_role mt-2"
      }, /*#__PURE__*/React.createElement(ExpertiseTagDropdown, {
        model: "higher_level_role",
        selection: roleSelection,
        handleSelect: this.handleRoleSelect,
        multi: false,
        isValidNewOption: function isValidNewOption() {
          return false;
        },
        isCreatable: false,
        heading: "Role",
        isDisabled: false,
        picklist: newProjectDetails.expertise_picklists.higher_level_role,
        loadOptions: function loadOptions(input) {
          return new Promise(function (resolve) {
            resolve(filterPicklist(newProjectDetails.expertise_picklists.higher_level_role, input));
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "project-expertise-select level mt-2"
      }, /*#__PURE__*/React.createElement(ExpertiseTagDropdown, {
        model: "level",
        selection: levelSelection,
        handleSelect: this.handleLevelSelect,
        handleCreate: function handleCreate() {},
        multi: true,
        isValidNewOption: function isValidNewOption() {
          return false;
        },
        isCreatable: false,
        heading: "Seniority",
        menuHeading: "What level of seniority will your project need?",
        isDisabled: false,
        picklist: newProjectDetails.expertise_picklists.level,
        checkboxOptions: true,
        loadOptions: function loadOptions(input) {
          return new Promise(function (resolve) {
            resolve(filterPicklist(expertisePicklists.level, input));
          });
        }
      })), showFullTimeOption && this.renderEmploymentChoice(), (!showFullTimeOption || employmentType === 'consulting') && [this.renderProjectLengthQuestion(), this.renderProjectHoursQuestion()], this.renderButtons())));
    }
  }, {
    key: "renderModalLink",
    value: function renderModalLink() {
      return /*#__PURE__*/React.createElement("i", {
        role: "button",
        tabIndex: 0,
        className: "fa fa-edit modal-link",
        onClick: this.handleShowModal
      }, this.props.formType === 'modal-link' ? 'Edit' : '');
    }
  }, {
    key: "renderEmploymentChoice",
    value: function renderEmploymentChoice() {
      var newProjectDetails = this.props.newProjectDetails;
      var employmentType = this.state.employmentType;
      return /*#__PURE__*/React.createElement("div", {
        className: "employment-type-container"
      }, /*#__PURE__*/React.createElement("h3", null, "Employment Type", /*#__PURE__*/React.createElement("span", {
        className: "heading-required"
      }, "* Required")), /*#__PURE__*/React.createElement(FilterTag, {
        options: newProjectDetails.employment_type_options,
        handleChange: this.handleEmploymentTypeSelect,
        selected: employmentType
      }));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.formType === 'page') {
        return this.renderContent();
      }
      return /*#__PURE__*/React.createElement("div", null, this.renderModalLink(), this.renderModal());
    }
  }]);
}(Component);
ProjectName.propTypes = {
  formType: PropTypes.string,
  // one of 'page', 'modal-link', 'modal-icon'
  projectResourceId: PropTypes.string,
  projectUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  projectName: PropTypes.string,
  afterSubmit: PropTypes.func,
  back: PropTypes.func,
  setProjectResourceId: PropTypes.func.isRequired,
  getProjectDetails: PropTypes.func.isRequired,
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isAdmin: PropTypes.bool,
  companyPicklist: PropTypes.arrayOf(PropTypes.shape({})),
  duplicationProjectResourceId: PropTypes.string,
  rehireUserResourceId: PropTypes.string,
  backButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
  favoritedConsultant: PropTypes.string,
  newProjectDetails: PropTypes.shape({
    expertise_picklists: PropTypes.shape({}),
    expertise_tags: PropTypes.shape({}),
    employment_type: PropTypes.string,
    duration_unit: PropTypes.string,
    avg_time_required_range: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    avg_time_required_unit: PropTypes.string
  }),
  userId: PropTypes.string.isRequired,
  projectTemplatesPath: PropTypes.string,
  showFullTimeOption: PropTypes.bool.isRequired,
  projectTemplateId: PropTypes.string,
  jobDescriptionUpload: PropTypes.bool
};
ProjectName.defaultProps = {
  formType: 'page',
  projectResourceId: null,
  duplicationProjectResourceId: null,
  rehireUserResourceId: null,
  projectName: '',
  afterSubmit: function afterSubmit() {},
  back: function back() {},
  companyId: '',
  isAdmin: false,
  companyPicklist: [],
  backButtonText: 'Back',
  submitButtonText: 'Next',
  favoritedConsultant: null,
  newProjectDetails: {},
  projectTemplatesPath: null,
  projectTemplateId: null,
  jobDescriptionUpload: false
};
export default ProjectName;